import * as React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { customerReferences } from "./customerReferences";

export default function LogoCollection() {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Container
      id="logoCollection"
      sx={{
        py: { xs: 6, sm: 10 },
        opacity: 1,
      }}
    >
      <Typography
        component="h2"
        variant="h4"
        sx={{
          textAlign: "center",
          color: 'text.primary',
          fontWeight: 600,
          mb: { xs: 4, sm: 6 }
        }}
      >
        {t("landingpage.partners")}
      </Typography>
      
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 3,
          justifyContent: "center",
          alignItems: "center",
          margin: "0 auto",
        }}
      >
        {customerReferences.map((customer) => (
          <Box
            key={customer.key}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transition: "transform 0.3s ease",
            }}
          >
            <Tooltip title={customer.companyName} placement="bottom" arrow>
              <Box
                component="a"
                href={customer.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textDecoration: "none",
                  width: "280px",
                  height: "140px",
                  padding: "20px",
                  backgroundColor: "white",
                  borderRadius: 2,
                  border: `2px solid ${theme.palette.mode === 'dark' 
                    ? 'rgba(255, 255, 255, 0.2)' 
                    : 'rgba(0, 0, 0, 0.1)'}`,
                  boxShadow: theme.palette.mode === 'dark'
                    ? '0 4px 16px rgba(0, 0, 0, 0.3)'
                    : '0 4px 16px rgba(0, 0, 0, 0.08)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.palette.mode === 'dark'
                      ? '0 8px 32px rgba(0, 0, 0, 0.4)'
                      : '0 8px 32px rgba(0, 0, 0, 0.12)',
                    borderColor: theme.palette.mode === 'dark' 
                      ? 'rgba(255, 255, 255, 0.3)' 
                      : 'rgba(0, 0, 0, 0.2)',
                  }
                }}
              >
                <Box
                  component="img"
                  src={customer.logoUrl}
                  alt={customer.companyName}
                  sx={{
                    maxHeight: "100%",
                    maxWidth: "100%",
                    width: "auto",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              </Box>
            </Tooltip>
          </Box>
        ))}
      </Box>
    </Container>
  );
}